module.exports = __webpack_public_path__ + "img/nav-home.41da8929.svg";